(function () {
    angular
        .module('sodCommon')
        .filter('cleanseValue', cleanseValue);

    function cleanseValue(lodash) {
        return function (value) {
            return lodash.reduce(value, function(carry, _val, _key) {
                if (lodash.isBoolean(_val) || lodash.isNumber(_val) || lodash.isString(_val)) {
                    if (lodash.isString(_val) && _val.length <= 0) {
                        return carry;
                    }

                    carry[_key] = _val;
                    return carry;
                }
                
                if (lodash.isEmpty(_val)) {
                    return carry;
                }
                
                carry[_key] = _val;
                return carry;
            }, {});
        };
    }
})();